import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationService } from './request/authentication/authentication.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorinterceptorService } from './../services/interceptors/error/errorinterceptor.service';
import { AuthinterceptorService } from './../services/interceptors/auth/authinterceptor.service';
import { UserInfoService } from './request/user/userinfo.service';
import { ContactparamService } from './state/contactparam.service';
import { HistoryService } from './state/history/history.service';
import { FiltersService } from './request/filters/filters.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  providers: [
    AuthenticationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthinterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorinterceptorService,
      multi: true
    },
    UserInfoService,
    ContactparamService,
    HistoryService,
    FiltersService
  ]
})
export class ServicesModule { }
